export default [
    {
        component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-periodo-contabil' */ '@/views/web-service/almoxarifado/cliente/periodo-contabil/Index'),
        path: 'almoxarifado-cliente-periodo-contabil',
        redirect: 'almoxarifado-cliente-periodo-contabil/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-periodo-contabil' */'@/views/web-service/almoxarifado/cliente/periodo-contabil/List.vue'),
                name: 'web-service-almoxarifado-cliente-periodo-contabil-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'web-service-almoxarifado-cliente-periodo-contabil' */ '@/views/web-service/almoxarifado/cliente/periodo-contabil/Form.vue'),
                name: 'web-service-almoxarifado-cliente-periodo-contabil-create',
                path: 'create',
            },
        ],
    },
]